import { textureManager } from '../core/TextureManager.js';

export class ImageLoader {
    constructor() {
        // Use singleton texture manager instead of creating new instances
    }
    
    // Helper method to load textures with proper encoding
    loadTextureWithProperEncoding(url) {
        return textureManager.loadTextureWithProperEncoding(url);
    }
    
    // Get a cached DOM image synchronously
    getCachedDOMImage(url) {
        return textureManager.getCachedDOMImage(url);
    }
    
    // Get a cached DOM image from a texture URL
    getDOMImageFromTexture(url) {
        return textureManager.getDOMImageFromTexture(url);
    }
    
    // Clear the texture cache
    clearCache() {
        return textureManager.clearCache();
    }
    
    // Get image files for a specific sheet from JSON data
    async getSheetImageFiles(sheetId) {
        console.log(`ImageLoader: Loading images for sheet: ${sheetId}`);
        const { getSheetData } = await import('/src/config/SheetConfig.js');
        const sheetData = await getSheetData(sheetId);
        
        if (!sheetData) {
            console.warn(`ImageLoader: Warning - No config found for sheet: ${sheetId}`);
            return [];
        }
        
        // Extract filenames from the image objects
        const filenames = sheetData.images.map(img => img.filename);
        console.log(`ImageLoader: Found ${filenames.length} images in config`);
        return filenames;
    }
    
} 